export default "__VITE_ASSET__tadElVrN__"